(function ($) {
  Drupal.behaviors.howtolessons = {
    attach: function (context) {
      var $steps = $('.js-how-to-lesson-step--v1', context);
      var $productGrids = $('.how_to-lesson__step-product-grid', $steps);

      // Show the product grid on clicking the CTA within the step
      $steps.each(function () {
        var $me = $(this);
        var $button = $('.js-button', $me);
        var $grid = $('.how-to-product-grid', $me);
        var $closeButton = $('.js-close', $me);

        // Once page has loaded slide up the grid, this is to allow proper widths and heights
        $grid.slideUp();
        $button.on('click', function (e) {
          // Find other grids in the steps
          // Close the ones that are not this
          e.preventDefault();
          var $carousel = $('.js-product-carousel, .js-mpp-carousel', $me);
          var $shadesCarousel = $('.js-product-brief-shades__grid', $grid);

          $(this).toggleClass('active').attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
          var $showhideProduct = $('.js-how_to_product');

          site.restrict_navigation($showhideProduct);
          $grid.slideToggle();
          if ($carousel.length > 0) {
            $('.js-product-carousel, .js-mpp-carousel', $me)[0].slick.setPosition();
            // the v2 carousel, requires full reinit
            $carousel.trigger('deferred-carousel-load');
          }
          productGridHeights($me);
          $productGrids.not($grid).stop(true, true).hide();
          $('html, body').animate({
            scrollTop: $grid.offset().top - 150
          }, 500);
          $('.js-button.active', $steps).not($(this)).removeClass('active');
          $shadesCarousel.each(function () {
            $(this).getSlick().refresh();
          });
        });

        $closeButton.on('click', function (e) {
          $button.trigger('click');
          $button.focus();
        });

        // Keydown for close button
        $closeButton.on('keydown', function (e) {
          if (site.getKeycode(e) === 13) {
            $(this).trigger('click');
          }
        });
      });

      // Find the product grid, match their heights
      function productGridHeights($elem) {
        $('.product-grid__item', $elem).matchHeight();
      }
    }
  };
})(jQuery);
